import axios from 'axios';

var addresses = document.getElementById('addresses') || null;
var newAddress = document.getElementById('new-address') || null;
var addressPaymentTypeId =
    document.getElementById('address-payment-type_id') || null;
var editPaymentAddress =
    document.getElementById('edit-payment-address') || null;
var cancelPaymentAddressHeader =
    document.getElementById('cancel-payment-address-header') || null;
var cancelPaymentAddressFooter =
    document.getElementById('cancel-payment-address-footer') || null;
var cancelPaymentHeader =
    document.getElementById('cancel-address-header') || null;
var cancelPaymentFooter =
    document.getElementById('cancel-address-footer') || null;
var openDetail = document.getElementById('list-order') || null;

// Sezione Billing
if (editPaymentAddress) {
    var form = {};
    var formIdFields = [
        'address-payment-type_id',
        'address-payment-company',
        'address-payment-vatid',
        'address-payment-firstname',
        'address-payment-lastname',
        'address-payment-fiscal_code',
        'address-payment-address1',
        'address-payment-address_number',
        'address-payment-city',
        'address-payment-postal',
        'address-payment-state_id-0',
        'address-payment-state-0',
        'address-payment-countryid-0',
        'address-payment-telephone',
        'address-payment-mobile',
        'address-payment-email',
        'address-payment-invoice_pec',
        'address-payment-sdi_code',
        'address-payment-exempt_from_electronic_invoice'
    ];

    editPaymentAddress.addEventListener(
        'click',
        expandFormPaymentAddress,
        false
    );
    cancelPaymentAddressHeader.addEventListener(
        'click',
        reduceFormPaymentAddress,
        false
    );
    cancelPaymentAddressFooter.addEventListener(
        'click',
        reduceFormPaymentAddress,
        false
    );
}

if (addressPaymentTypeId) {
    document.addEventListener('DOMContentLoaded', (evt) => {
        if (addressPaymentTypeId.value == 1) {
            document.getElementById(
                'row-address-payment-company-vatid'
            ).style.display = 'none';
            document.getElementById(
                'row-address-payment-first-name-last-name'
            ).style.display = '';
            document.getElementById(
                'row-address-payment-fiscal_code'
            ).style.display = '';
            document.getElementById('address-payment-firstname').required =
                true;
            document.getElementById('address-payment-lastname').required = true;
            document.getElementById('address-payment-fiscal_code').required =
                true;
            document.getElementById('address-payment-company').required = false;
            document.getElementById('address-payment-vatid').required = false;
        } else {
            document.getElementById(
                'row-address-payment-company-vatid'
            ).style.display = '';
            document.getElementById(
                'row-address-payment-first-name-last-name'
            ).style.display = 'none';
            document.getElementById(
                'row-address-payment-fiscal_code'
            ).style.display = 'none';
            document.getElementById('address-payment-firstname').required =
                false;
            document.getElementById('address-payment-lastname').required =
                false;
            document.getElementById('address-payment-fiscal_code').required =
                false;
            document.getElementById('address-payment-company').required = true;
            document.getElementById('address-payment-vatid').required = true;
        }
    });

    $('#address-payment-type_id').on('change', changeForm);
}

function expandFormPaymentAddress(e) {
    extractFormFields(formIdFields);
    document.getElementById('group-button-header').classList.remove('hidden');
    document.getElementById('group-button-footer').classList.remove('hidden');
    $('#card-payment-address').collapse('hide');
    $('#form-payment-address').collapse('show');
}

function reduceFormPaymentAddress(e) {
    setFormFields(formIdFields);
    document.getElementById('group-button-header').classList.add('hidden');
    document.getElementById('group-button-footer').classList.add('hidden');
    $('#card-payment-address').collapse('show');
    $('#form-payment-address').collapse('hide');
}

function changeForm(e) {
    var valuePaymentTypeId = e.target.value;
    if (valuePaymentTypeId == 1) {
        document.getElementById(
            'row-address-payment-company-vatid'
        ).style.display = 'none';
        document.getElementById(
            'row-address-payment-first-name-last-name'
        ).style.display = '';
        document.getElementById(
            'row-address-payment-fiscal_code'
        ).style.display = '';
        document.getElementById('address-payment-firstname').required = true;
        document.getElementById('address-payment-lastname').required = true;
        document.getElementById('address-payment-fiscal_code').required = true;
        document.getElementById('address-payment-company').required = false;
        document.getElementById('address-payment-vatid').required = false;
    } else {
        document.getElementById(
            'row-address-payment-company-vatid'
        ).style.display = '';
        document.getElementById(
            'row-address-payment-first-name-last-name'
        ).style.display = 'none';
        document.getElementById(
            'row-address-payment-fiscal_code'
        ).style.display = 'none';
        document.getElementById('address-payment-firstname').required = false;
        document.getElementById('address-payment-lastname').required = false;
        document.getElementById('address-payment-fiscal_code').required = false;
        document.getElementById('address-payment-company').required = true;
        document.getElementById('address-payment-vatid').required = true;
    }
}

function extractFormFields(data) {
    data.forEach((value) => {
        if (document.getElementById(value)) {
            if (document.getElementById(value).type == 'checkbox') {
                form[value.replace(/-/g, '_')] =
                    document.getElementById(value).checked;
            } else {
                form[value.replace(/-/g, '_')] =
                    document.getElementById(value).value || null;
            }
        }
    });
}

function setFormFields(data) {
    data.forEach((value) => {
        if (document.getElementById(value)) {
            if (form[value.replace(/-/g, '_')]) {
                document
                    .getElementById(value)
                    .labels[0].classList.add('active');
            }
            if (
                value == 'address-payment-type_id' ||
                value == 'address-payment-countryid-0' ||
                value == 'address-payment-state_id-0'
            ) {
                $('#' + value).val(form[value.replace(/-/g, '_')]);
                $('#' + value)
                    .select()
                    .trigger('change');
            } else {
                if (document.getElementById(value).type == 'checkbox') {
                    document.getElementById(value).checked =
                        form[value.replace(/-/g, '_')];
                } else {
                    document.getElementById(value).value =
                        form[value.replace(/-/g, '_')];
                }
            }
        }
    });
}

// Sezione Shipping Addresses

if (addresses) {
    addresses.addEventListener('click', expandForm, false);
    cancelPaymentFooter.addEventListener('click', reduceFormAddresses, false);
    var formAddresses = {};
    var indexes = Array();
    var formIdFieldsAddresses = [
        'address-delivery-firstname',
        'address-delivery-lastname',
        'address-delivery-email',
        'address-delivery-address1',
        'address-delivery-address_number',
        'address-delivery-city',
        'address-delivery-postal',
        'address-delivery-state_id',
        'address-delivery-state',
        'address-delivery-countryid',
        'address-delivery-telephone',
        'address-delivery-default_address'
    ];
    document.addEventListener('DOMContentLoaded', (evt) => {
        document.querySelectorAll('.card-summary-address').forEach((value) => {
            var index = value.id.split('-', 5)[4];
            indexes.unshift(index);
        });

        indexes.forEach((value) => {
            extractFormFieldsAddresses(formIdFieldsAddresses, value);
        });
    });
}

if (newAddress) {
    document.addEventListener('DOMContentLoaded', function () {
        $('#account-profile-delivery-address-body-n').collapse('hide');
    });
    newAddress.addEventListener('click', hideForm, false);
}

function extractFormFieldsAddresses(data, index) {
    data.forEach((value) => {
        if (document.getElementById(value + '-' + index)) {
            if (
                document.getElementById(value + '-' + index).type == 'checkbox'
            ) {
                formAddresses[value.replace(/-/g, '_') + '_' + index] =
                    document.getElementById(value + '-' + index).checked;
            } else {
                formAddresses[value.replace(/-/g, '_') + '_' + index] =
                    document.getElementById(value + '-' + index).value || null;
            }
        }
    });
}

function setFormAddresses(data, index) {
    data.forEach((value) => {
        if (document.getElementById(value + '-' + index)) {
            if (formAddresses[value.replace(/-/g, '_') + '_' + index]) {
                document
                    .getElementById(value + '-' + index)
                    .labels[0].classList.add('active');
            } else {
                document
                    .getElementById(value + '-' + index)
                    .labels[0].classList.remove('active');
            }
            if (
                value == 'address-delivery-state_id' ||
                value == 'address-delivery-countryid'
            ) {
                $('#' + value + '-' + index).val(
                    formAddresses[value.replace(/-/g, '_') + '_' + index]
                );
                $('#' + value + '-' + index)
                    .select()
                    .trigger('change');
            } else {
                if (
                    document.getElementById(value + '-' + index).type ==
                    'checkbox'
                ) {
                    document.getElementById(value + '-' + index).checked =
                        formAddresses[value.replace(/-/g, '_') + '_' + index];
                } else {
                    document.getElementById(value + '-' + index).value =
                        formAddresses[value.replace(/-/g, '_') + '_' + index];
                }
            }
        }
    });
}

function expandForm(e) {
    var action = e.target.getAttribute('action');
    document
        .getElementById('group-button-addresses-footer')
        .classList.remove('hidden');
    $('#account-profile-delivery-address-body-n').collapse('hide');
    document.getElementById('new-address').style.display = 'inline';
    if (e.target !== e.currentTarget && action == 'editForm') {
        document
            .getElementById('address-delivery-firstname-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-lastname-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-email-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-address1-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-address_number-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-city-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-postal-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-countryid-n')
            .removeAttribute('required');
        document
            .getElementById('address-delivery-telephone-n')
            .removeAttribute('required');

        document
            .getElementsByName('address[delivery][customer.address.id][-1]')[0]
            .setAttribute('disabled', 'disabled');
        var clickedItem = e.target.id;
        $('#card-summary-' + clickedItem).collapse('show');
        var checkShow = document
            .getElementById(clickedItem + '-delivery-address-card')
            .classList.contains('show');
        if (!checkShow) {
            $('#' + clickedItem + '-delivery-address-card').collapse('show');
            var forms = document.querySelectorAll('.card-address');
            forms.forEach((value, key, parent) => {
                if (value.id != clickedItem + '-delivery-address-card') {
                    $(
                        '#card-summary-' + value.id.split('-', 3).join('-')
                    ).collapse('show');
                    $('#' + value.id).collapse('hide');
                }
            });
        } else {
            $('#' + clickedItem + '-delivery-address-card').collapse('hide');
        }
    }

    e.stopPropagation();
}

function reduceFormAddresses(e) {
    document
        .getElementById('group-button-addresses-footer')
        .classList.add('hidden');
    $('#account-profile-delivery-address-body-n').collapse('hide');
    document.getElementById('new-address').style.display = 'inline';
    var forms = document.querySelectorAll('.card-address');
    forms.forEach((value, key, parent) => {
        $('#card-summary-' + value.id.split('-', 3).join('-')).collapse('show');
        $('#' + value.id).collapse('hide');
    });

    indexes.forEach((value) => {
        setFormAddresses(formIdFieldsAddresses, value);
    });

    document.getElementById('address-delivery-firstname-n').value = '';
    document
        .getElementById('address-delivery-firstname-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-lastname-n').value = '';
    document
        .getElementById('address-delivery-lastname-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-email-n').value = '';
    document
        .getElementById('address-delivery-email-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-address1-n').value = '';
    document
        .getElementById('address-delivery-address1-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-address_number-n').value = '';
    document
        .getElementById('address-delivery-address_number-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-city-n').value = '';
    document
        .getElementById('address-delivery-city-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-postal-n').value = '';
    document
        .getElementById('address-delivery-postal-n')
        .labels[0].classList.remove('active');
    $('#address-delivery-state_id-n').val('');
    $('#address-delivery-state_id-n').select().trigger('change');
    $('#address-delivery-countryid-n').val('');
    $('#address-delivery-countryid-n').select().trigger('change');
    document
        .getElementById('address-delivery-countryid-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-telephone-n').value = '';
    document
        .getElementById('address-delivery-telephone-n')
        .labels[0].classList.remove('active');
    document.getElementById('address-delivery-default_address-n').checked =
        false;
}

function hideForm(e) {
    document
        .getElementById('group-button-addresses-footer')
        .classList.remove('hidden');
    var forms = document.querySelectorAll('.card-address');
    var summary = document.querySelectorAll('.card-summary-address');
    forms.forEach((value, key, parent) => {
        $('#' + value.id).collapse('hide');
    });

    summary.forEach((value, key, parent) => {
        $('#' + value.id).collapse('show');
    });

    $('#account-profile-delivery-address-body-n').collapse('show');
    document
        .getElementById('address-delivery-firstname-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-lastname-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-email-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-address1-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-address_number-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-city-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-postal-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-countryid-n')
        .setAttribute('required', 'required');
    document
        .getElementById('address-delivery-telephone-n')
        .setAttribute('required', 'required');
    document
        .getElementsByName('address[delivery][customer.address.id][-1]')[0]
        .removeAttribute('disabled');
}

$(document).ready(function () {
    var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');

    $('#address-payment-countryid').on('change', function (e) {
        $('#address-payment-state').prop('disabled', true).val(null);
        $('#address-payment-state_id')
            .prop('disabled', true)
            .val(null)
            .trigger('change');

        //Carico province
        axios
            .post('/api/states', {
                countryId: $('#address-payment-countryid').val()
            })
            .then(function (response) {
                let states = [];
                if (response.data) {
                    for (let dataId in response.data) {
                        let state = {
                            id: dataId,
                            text: response.data[dataId]
                        };
                        states.push(state);
                    }
                }

                if (states.length > 0) {
                    $('#address-payment-state')
                        .prop('disabled', false)
                        .prop('required', false)
                        .parent()
                        .parent()
                        .hide();
                    $('#address-payment-state_id')
                        .prop('disabled', false)
                        .prop('required', true)
                        .parent()
                        .parent()
                        .show();
                    $('#address-payment-state_id')
                        .data('select2')
                        .dataAdapter.updateOptions(states);
                } else {
                    $('#address-payment-state_id')
                        .prop('disabled', false)
                        .prop('required', false)
                        .parent()
                        .parent()
                        .hide();
                    $('#address-payment-state')
                        .prop('disabled', false)
                        .prop('required', true)
                        .parent()
                        .parent()
                        .show();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    });

    $('#address-payment-state_id').select2({
        theme: 'bootstrap4',
        minimumResultsForSearch: 10,
        dataAdapter: customAdapter,
        placeholder: function () {
            $(this).data('placeholder');
        }
    });

    $('.new-address :input').each(function () {
        $(this).prop('required', false);
    });

    $('[id^="address-delivery-countryid-"]').on('change', function (e) {
        let elemId = $(this).data('num');

        $('#address-delivery-state-' + elemId)
            .prop('disabled', true)
            .val(null);
        $('#address-delivery-state_id-' + elemId)
            .prop('disabled', true)
            .val(null)
            .trigger('change');

        //Carico province
        axios
            .post('/api/states', {
                countryId: $('#address-delivery-countryid-' + elemId).val()
            })
            .then(function (response) {
                let states = [];
                if (response.data) {
                    for (let dataId in response.data) {
                        let state = {
                            id: dataId,
                            text: response.data[dataId]
                        };
                        states.push(state);
                    }
                }

                if (states.length > 0) {
                    $('#address-delivery-state-' + elemId)
                        .prop('disabled', false)
                        .prop('required', false)
                        .parent()
                        .parent()
                        .hide();
                    $('#address-delivery-state_id-' + elemId)
                        .prop('disabled', false)
                        .prop('required', true)
                        .parent()
                        .parent()
                        .show();
                    $('#address-delivery-state_id-' + elemId)
                        .data('select2')
                        .dataAdapter.updateOptions(states);
                } else {
                    $('#address-delivery-state_id-' + elemId)
                        .prop('disabled', false)
                        .prop('required', false)
                        .parent()
                        .parent()
                        .hide();
                    $('#address-delivery-state-' + elemId)
                        .prop('disabled', false)
                        .prop('required', true)
                        .parent()
                        .parent()
                        .show();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    });

    $('[id^="address-delivery-state_id-"]').select2({
        theme: 'bootstrap4',
        minimumResultsForSearch: 10,
        dataAdapter: customAdapter,
        placeholder: function () {
            $(this).data('placeholder');
        }
    });
});

$('.btn-shipping-edit').on('click', function (ev) {
    $('.new-address :input').each(function () {
        $(this).prop('required', false);
    });
});

$('.account-profile').on('click', 'button.act-delete', function () {
    $(this).parents('.card').remove();
    return false;
});

$('.account-profile').on('click', 'button.act-new', function (ev) {
    var item = $('.prototype', ev.delegateTarget).removeClass('prototype');
    $('input,select', item).prop('required', true);
    $(this).hide();
    return false;
});

$('.account-delete').on('click', 'button.btn-delete', function (ev) {
    let confirm = window.confirm('Are you sure?');
    if (confirm) {
        axios.post('/delete_user').then(function () {
            document.location.href = '/';
            location.reload();
        });
    }
});

// Sezione storico ordini

$('.account-history .history-data').on('click', '.open-detail', function (ev) {
    var card = ev.currentTarget.closest('.history-data');
    var detailOrder = document.querySelectorAll('.float-right.open-detail');
    var faMinus = document.querySelectorAll('.fa-minus');

    var details = $('.account-history-order', ev.delegateTarget);

    if (details.length === 0) {
        var a = $(this);
        $('i', a).toggleClass('fa-plus fa-spinner-third').addClass('fa-spin');
        $.get($(this).attr('href'), function (data) {
            var doc = document.createElement('html');
            doc.innerHTML = data;
            var node = $('.account-history-order', doc);
            node.css('display', 'none');
            $(ev.delegateTarget).append(node);
            node.slideDown();
            $('i', a)
                .removeClass('fa-spin')
                .toggleClass('fa-spinner-third fa-minus');
            card.classList.add('btn-service');
            card.classList.add('selected');
        });

        detailOrder.forEach((value, index) => {
            if (value.href != ev.currentTarget.href) {
                var collection = value.children;
                const historyData = value.closest('.history-data');
                if (
                    historyData &&
                    typeof historyData.lastChild.classList !== 'undefined'
                ) {
                    if (
                        historyData.lastChild.classList.contains(
                            'account-history-order'
                        )
                    ) {
                        document
                            .getElementById('order-detail-' + value.id)
                            .classList.add('fa-plus');
                        historyData.lastChild.style.display = 'none';
                        historyData.setAttribute('style', '');
                        historyData.classList.remove('btn-service');
                        historyData.classList.remove('selected');
                    }
                }
            }
        });
    } else {
        $('i', this).toggleClass('fa-plus');
        card.setAttribute('style', '');
        card.classList.remove('btn-service');
        card.classList.remove('selected');
        details.slideToggle();

        detailOrder.forEach((value, index) => {
            if (value.href != ev.currentTarget.href) {
                var collection = value.children;
                const historyData = value.closest('.history-data');
                if (
                    historyData &&
                    typeof historyData.lastChild.classList !== 'undefined'
                ) {
                    if (
                        historyData.lastChild.classList.contains(
                            'account-history-order'
                        )
                    ) {
                        document
                            .getElementById('order-detail-' + value.id)
                            .classList.add('fa-plus');
                        historyData.lastChild.style.display = 'none';
                        historyData.setAttribute('style', '');
                        historyData.classList.remove('btn-service');
                        historyData.classList.remove('selected');
                    }
                }
            }
        });
    }

    if (
        ev.target.classList.contains('fa-minus') &&
        !ev.target.classList.contains('fa-plus')
    ) {
        card.classList.add('btn-service');
        card.classList.add('selected');
    } else {
        card.classList.remove('btn-service');
        card.classList.remove('selected');
    }

    return false;
});

var orderPaymentList = document.getElementById('order-payment-list') || null;

if (orderPaymentList) {
    orderPaymentList.addEventListener('click', (ev) => {
        if (ev.target.getAttribute('data-action') == 'pay-now') {
            document.getElementById(ev.target.id + '-loading').innerHTML =
                '<i class="fas fa-spinner fa-spin"></i>';
            ev.preventDefault();
            axios
                .get(window.location.href + '?type=payment&id=' + ev.target.id)
                .then((res) => {
                    $('body').html(res.data);
                    form = document.getElementById('form-post-payment');
                    if (form) {
                        form.submit();
                    } else {
                        window.location =
                            document.getElementById('link-payment').innerText;
                    }
                });
        }
    });
}

$(document).ready(function () {
    if (
        typeof addressBillingError === 'object' &&
        Object.keys(addressBillingError).length > 0
    ) {
        $('#billing-address-modal').modal('show');
    }
});
